<template>
  <v-data-table
    :headers="headers"
    :items="desserts"
    :search="search"
    item-value="name"
    class="elevation-1"
    density="compact"
    height="200"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Buscar..."
          single-line
          variant="underlined"
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.Dato="{ item }">
      <div>
        {{ item.raw.Dato + "-" + item.raw.DescDato }}
      </div>
    </template>
    <template v-slot:item.Valor_Unico="{ item }">
      <div>
        {{ item.raw.Valor_Unico + " " + item.raw.DescValor_Unico }}
      </div>
    </template>
  </v-data-table>
  <div class="d-flex align-center flex-column">
    <!-- Linea de progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "Auditoria",
  props: {
    NumeroSolicitud: {
      type: Number,
      default: 0,
      Description: "Numero de Solicitud",
    },
    datoid: {
      type: Number,
      default: 0,
      Description: "Dato Auditado",
    },
  },
  data() {
    return {
      search: "",
      progreso: false,
      datoses: false,
      headers: [
        {
          title: "Dato",
          align: "start",
          key: "Dato",
        },
        {
          title: "Contenido Dato",
          align: "start",
          key: "Valor_Unico",
        },
        {
          title: "Usuario Actualizó",
          align: "start",
          key: "DescUsuarioActualizo",
        },
        {
          title: "Fecha Actualizó",
          align: "start",
          key: "FechaActualizo",
        },
      ],
      desserts: [],
    };
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Consulta Solicitudes
    async getHistoricoDatos() {
      this.desserts = [];
      this.progreso = true;
      this.axios
        .get(
          "/Procesos/AuditoriaDato/getInfoAuditoriaDato/" +
            this.NumeroSolicitud +
            "/" +
            this.datoid
        )
        .then((result) => {
          this.desserts = result.data;
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: " [404] No existen datos para esta consulta.",
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    ///////////////////////////////////////////////// Métodos de acciones //////////////////////////////////////////
  },
  mounted() {
    this.getHistoricoDatos();
  },
};
</script>
